import React from "react";

export default function ProjectGalleryItem(mediaObject) {
  const { code, url, title, altTag, attributes } = mediaObject;
  const projectNumber = attributes.attribute.find(attr => attr["@name"] === "Proposal")["@value"];

  return (
    <div className="strip-item thumbnail" key={code}>
      <a target="_blank" href={`/ProjectGallery/${projectNumber}`} className="g-link">
        <img
            u="image"
            src={url}
            title={title}
            border="0"
            alt={altTag}
        />
        <div className="text-center g-caption">{title}</div>
      </a>
    </div>
  );
}
